import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import { styled } from '../../styled';
import { BlockedChatIcon } from '../blockedChat/blockedChatIcon';
import { msgs } from './msgs';

type Interface = { className: string };

const Component = observer(({ className }: Interface): ReactElement => {
	const intl = useIntl();
	return (
		<div className={className}>
			<BlockedChatIcon />
			<span>{intl.formatMessage(msgs.chatRecovery)}</span>
		</div>
	);
});

const ErrorShowcaseContainer = styled(Component)(css`
	box-sizing: border-box;
	color: #777c87;
	font-size: 18px;
	padding: 0 18px;
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 100%;
	overflow: hidden;

	& > span {
		margin-top: 30px;
		text-align: center;
		margin-bottom: 10px;
		width: 100%;
	}

	& > div {
		&:hover,
		&:active,
		&:focus {
			background-color: #fe723526;
		}
	}
`);

export { ErrorShowcaseContainer };
